import styles from "./BackgroundImage.module.scss";

const BackgroundImage = ({ landscape, style }) => {
  return (
    landscape && (
      <div className={styles["background"]} style={style}>
        <img
          src={landscape}
          alt="wallpaper"
          className={styles["background-image"]}
        />
        <div className={styles["black-filter"]}></div>
      </div>
    )
  );
};

export default BackgroundImage;
